import api from "../../services/api";

const useConnections = () => {
	const findAll = async () => {
        const { data } = await api.get("/whatsapp");
        return data;
    }

	return { findAll };
};

export default useConnections;
